// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-container[data-v-03d9b622] {\n  text-align: center;\n  justify-content: center;\n  padding: 50px;\n}\n.button-container[data-v-03d9b622] {\n    margin-top: 30px;\n}\n.btn[data-v-03d9b622] {\n    margin: 10px;\n    padding: 10px 20px;\n    font-size: 18px;\n}\n  \n  /* Additional styling as required */\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
